export const GET_INVITATIONS = 'GET_INVITATIONS';
export const GET_INVITATIONS_REQUEST = 'GET_INVITATIONS_REQUEST';
